/* eslint-disable bsky-internal/avoid-unwrapped-text */
import './LoginForm.css'

import {Trans} from '@lingui/react/macro'

import {TOKENS} from '#/wsocial/service/design-system/tokens'
import logoSvg from '../../../assets/icon-wsocial.svg'

const T = {
  bg: TOKENS.dark.custom_background_primary,
  textMedium: '#D0CFD7',
  accent: TOKENS.dark.positive_700,
  btnText: TOKENS.dark.custom_text_light,
  borderLow: TOKENS.dark.custom_border_contrast_low,
} as const

export function StepPasswordUpdated({onDone}: {onDone: () => void}) {
  return (
    <div
      className="LoginPageShell"
      style={{
        backgroundColor: T.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: '100vh',
      }}>
      <div
        className="LoginPageShellInner"
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100%',
        }}>
        {/* Logo */}
        <div
          className="LoginLogoBlock"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <img src={logoSvg} alt="W Social" style={{width: 80, height: 80}} />
        </div>

        {/* Heading */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            padding: '0 16px',
          }}>
          <h1
            style={{
              fontSize: 30,
              fontWeight: 700,
              lineHeight: '35px',
              color: '#fff',
              margin: 0,
            }}>
            <Trans>Password updated</Trans>
          </h1>
          <p
            style={{
              fontSize: 13,
              fontWeight: 400,
              lineHeight: '17px',
              color: T.textMedium,
              margin: 0,
            }}>
            <Trans>Your password has been successfully updated.</Trans>
          </p>
        </div>

        {/* Button */}
        <div style={{padding: '24px 16px'}}>
          <button
            onClick={onDone}
            className="SignInContinueBtn"
            style={{
              backgroundColor: T.accent,
              color: T.btnText,
              fontSize: 15,
              fontWeight: 500,
              lineHeight: '20px',
              padding: '0 25px',
              height: 44,
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}>
            <Trans>Sign in</Trans>
          </button>
        </div>

        {/* Support footer */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            padding: '16px 16px',
          }}>
          <div
            style={{height: 1, backgroundColor: T.borderLow, width: '100%'}}
          />
          <p
            style={{
              fontSize: 13,
              fontWeight: 400,
              lineHeight: '17px',
              color: T.textMedium,
              margin: 0,
            }}>
            <Trans>Having trouble?</Trans>{' '}
            <a href="mailto:support@wsocial.eu" className="LinkNew">
              <Trans>Contact support</Trans>
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
